import { render } from "./reteData.vue?vue&type=template&id=4863d75c&ts=true"
import script from "./reteData.vue?vue&type=script&lang=ts"
export * from "./reteData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__